
export default function Select({label, options, selectedValue, onChange}) {
  return (
    <label>
      {label}
      <select
        value={selectedValue}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      >
        {options.map((option) => {
          return (
            <option value={option.value} key={option.value} >
              {option.label}
            </option>
          )
        }
        )}
      </select>
    </label>
  );
}
